// ------------------------------------
// Constants
// ------------------------------------

export const UPDATE_AUDIO_TIME = 'UPDATE_AUDIO_TIME'
export const HIDE_SECONDARY_AUDIO = 'HIDE_SECONDARY_AUDIO'
export const REMOVE_AUDIO_TIME = 'REMOVE_AUDIO_TIME'

// ------------------------------------
// Actions
// ------------------------------------

export function updateAudioTime(payload) {
  return {
    type: UPDATE_AUDIO_TIME,
    payload
  }
}

export function hideSecondaryAudio() {
  return {
    type: HIDE_SECONDARY_AUDIO
  }
}

export function removeAudioTime() {
  return {
    type: REMOVE_AUDIO_TIME
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  src: null,
  currentTime: null,
  isPlaying: false,
  showSecondary: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_AUDIO_TIME: {
      const { src, currentTime, isPlaying, showSecondary } = action.payload
      return {
        src,
        currentTime,
        isPlaying,
        showSecondary
      }
    }
    case HIDE_SECONDARY_AUDIO: {
      return {
        ...state,
        showSecondary: false
      }
    }
    case REMOVE_AUDIO_TIME: {
      return initialState
    }
  }
  return state
}
